import { gql } from '@lcs/shared/api';

export const getRoleDetail = gql`
   query GetRoleDetail($id: UInt!, $extensionFilter: String, $extensionGroupFilter: String) {
      role(id: $id) {
         roleId
         name
         description
         account {
            accountId
            name
         }
         userRolesCount
         rolePrivilegesConnection {
            items {
               rolePrivilegeId
               privilegeId
               roleId
               accountId
               isAdd
               isView
               isEdit
               isDelete
               isEnabled
            }
         }
         roleCallRecordingExtensionsConnection {
            items {
               roleCallRecordingExtensionId
               roleId
               extension {
                  extensionId
                  name
                  number
               }
               isInclude
            }
         }
         roleCallRecordingExtensionGroupsConnection {
            items {
               roleCallRecordingExtensionGroupId
               roleId
               extensionGroupId
               extensionGroup {
                  extensionGroupId
                  name
                  description
               }
               isInclude
            }
         }
         hasAllExtensionRecordings
         createDate
         createUser {
            userId
            name
         }
         updateDate
         updateUser {
            userId
            name
         }
         roleReportsConnection {
            items {
               roleReportId
               roleId
               report {
                  reportId
                  reportDefinition
               }
            }
         }
         userRolesConnection {
            totalCount
            items {
               userId
               roleId
            }
         }
      }
      extensionsConnection(filters: $extensionFilter) {
         items {
            extensionId
            number
            name
            accountId
            isArchived
         }
      }
      extensionGroupsConnection(filters: $extensionGroupFilter) {
         items {
            extensionGroupId
            name
            description
            accountId
         }
      }
   }
`;

export const getPrivileges = gql`
   query GetPrivileges {
      privilegesConnection {
         items {
            privilegeId
            name
            displayName
            description
            sortOrder
            isSystem
            isHidden
            categoryId
            privilegeCategory {
               privilegeCategoryId
               name
               description
               sortOrder
            }
            isAdd
            isView
            isEdit
            isDelete
            isEnabled
         }
      }
   }
`;

export const getRoleAccountId = gql`
   query GetRoleAccountId($id: UInt!) {
      role(id: $id) {
         accountId
      }
   }
`;
